import * as z from "zod";

export const overrideNotReceivedGroups = {
  name: "overrideNotReceivedGroups" as const,
  input: z.object({ fulfillmentGroupIds: z.array(z.string()) }),
  output: z.void(),
};
